import { Component, OnInit, ElementRef, Input, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding, EventEmitter } from '@angular/core';
import { LineThicknesses, DashInfo, DashID, DashInfoRecord } from 'app/types/drawing/dashed-lines';


@Component({
  selector: 'app-line-style-swatch',
  templateUrl: './line-style-swatch.component.html',
  styleUrls: ['./line-style-swatch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LineStyleSwatchComponent implements OnInit {
  @HostBinding('attr.tabindex') tabIndex = 0;
  public _ready = false;

  private _width: number = 0;
  private _dash?: DashInfoRecord;
  @Input()
  set dash(dashId: DashID) {
    this._dash = DashInfo[dashId] as DashInfoRecord;
    this.Refresh();
  }
  _color: string = '#000000'
  @Input()
  set color(color: string) {
    this._color = color;
    this.Refresh();
  }
  get color(): string {
    return this._color;
  }

  private _fillColor = '#EFEFEF';
  @Input()
  set fillColor(c: string) {
    this._fillColor = c;
    this.Refresh();
  }
  get fillColor(): string {
    return this._fillColor;
  }

  private _thickness: number = LineThicknesses.medium;
  @Input()
  set thickness(width: LineThicknesses) {
    this._thickness = width;

  }
  get thickness(): LineThicknesses {
    return this._thickness;
  }
  @Input()
  set width(w: number) {
    this._width = Number(w);
    this.Refresh();
  }
  get width(): number {
    return this._width;
  }
  private _height: number = 0;
  @Input()
  set height(h: number) {
    this._height = Number(h);
    this.Refresh();
  }
  get height(): number {
    return this._height;
  }

  public get lineY(): string {
    return '' + (this._height / 2.0);
  }

  public get swatchPolyPoints(): string {
    return `0 0,${this._width} 0,${this._width} ${this.height}, 0 ${this.height},0 0`
  }

  public get swatchDashArray(): string {
    if (!this._dash) return '';
    let dashStr = '';
    if (this._dash.dash === 100) return '';
    const dashSize = this._dash.dash; // * this._width/100.0;
    const gapSize = this._dash.gap; // * this._width/100.0;
    const dotSize = 2; // * this._width/100.0;
    dashStr += dashSize + ' ' + gapSize;
    if (this._dash.dots) {
      for (let i = 0; i < this._dash.dots; i++) {
        dashStr += ` ${dotSize} ${gapSize}`;
      }
    }
    return dashStr;
  }

  public get swatchDashOffset(): string {
    if (!this._dash) return '';
    if (this._dash.dash === 100) return '';
    if (!this._dash.offset) return '';
    return '' + this._dash.offset;
  }

  constructor(
    private domNode: ElementRef,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this._ready = true;

  }
  Focus() {
    this.domNode.nativeElement.focus();
  }
  Refresh() {
    if (this._ready) {
      this.cdr.detectChanges();
    }
  }

}
